import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
  RelatedBlogsAndNewsSlider,
  RelatedBlogAndNewsSliderProps
} from './RelatedBlogsAndNewsSlider';
const defaultQueryClient = new QueryClient();

const RelatedBlogAndNewsSliderGraphQL = ({
  title,
  tag,
  currentPageId,
  imgFallback,
  noBackground
}: RelatedBlogAndNewsSliderProps) => {
  return (
    <QueryClientProvider client={defaultQueryClient}>
      <RelatedBlogsAndNewsSlider
        title={title}
        tag={tag}
        currentPageId={currentPageId}
        imgFallback={imgFallback}
        noBackground={noBackground}
      />
    </QueryClientProvider>
  );
};

export default RelatedBlogAndNewsSliderGraphQL;
